import { Dayjs } from 'dayjs';
import { forwardRef, useImperativeHandle, useMemo } from 'react';
import { DatePicker, FocusRef } from '../../components';
import { createFocusHandle, createOnBlur } from './focusHandlers';
import { FilterInputProps } from './FilterInputProps';
import {
  DATE_FORMAT,
  FormattedDate,
  getDayjs,
  getIsoDateFromFormattedDate,
} from '../../utils';

export const ValidPeriodFilterInput = forwardRef<FocusRef, FilterInputProps>(
  ({ header, onBlur }, ref) => {
    const id = `${header.column.id}-filter-input`;

    useImperativeHandle(ref, () => createFocusHandle(id));
    const handleOnBlur = useMemo(
      () => createOnBlur([id, `${id}-popup`], onBlur),
      [id, onBlur]
    );

    const filterValue = header.column.getFilterValue() as
      | [FormattedDate | null, FormattedDate | null]
      | undefined;

    const value = useMemo(
      () =>
        filterValue?.map(
          (v) => v && getDayjs(getIsoDateFromFormattedDate(v))!
        ) as [Dayjs | null, Dayjs | null],
      [filterValue]
    );

    return (
      <DatePicker.RangePicker
        id={id}
        className={id}
        classNames={{
          popup: { root: `${id}-popup` },
        }}
        allowEmpty={[true, true]}
        format={DATE_FORMAT}
        allowClear
        value={value}
        onChange={(dayjsDates, formattedDates) =>
          header.column.setFilterValue(
            formattedDates?.some(Boolean) ? formattedDates : undefined
          )
        }
        // Prevent the event from bubbling up to dropdown component
        onKeyDown={(event) => {
          event.stopPropagation();
        }}
        onClick={(event) => {
          event.stopPropagation();
        }}
        onBlur={handleOnBlur}
      />
    );
  }
);
